import React from 'react';
import Footer from './components/Footer';
import Home from './components/Home';
import './style.css';

function App() {
  return (
    <div className="App">
      <Home/>
      <Footer/>
    </div>
  );
}

export default App;
